"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var react_redux_1 = require("react-redux");
var single_1 = require("utils/selectors/single");
var LoadingNotification_1 = __importDefault(require("./LoadingNotification"));
var ConnectAccounting = function (_a) {
    var notifications = _a.notifications;
    var company = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var notif = notifications[0];
    if (!(company === null || company === void 0 ? void 0 : company.hasRefreshToken)) {
        return ((0, jsx_runtime_1.jsxs)(LoadingNotification_1.default, { children: ["We are ", (0, jsx_runtime_1.jsx)("strong", { children: "connecting" }), " to ", (0, jsx_runtime_1.jsx)("strong", { children: (0, end2end_1.getNiceProvider)(notif) }), " from", ' ', (0, jsx_runtime_1.jsx)("strong", { children: "Hudled" }), "."] }));
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["We have ", (0, jsx_runtime_1.jsx)("strong", { children: "securely" }), " connected ", (0, jsx_runtime_1.jsx)("strong", { children: "Hudled" }), " with your account in", ' ', (0, jsx_runtime_1.jsx)("strong", { children: (0, end2end_1.getNiceProvider)(notif) }), "."] }));
};
exports.default = ConnectAccounting;
